var clamp = function (min, max, v) {
    return Math.min(Math.max(v, min), max);
};

export { clamp };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/node_modules/popmotion/dist/es/utils/clamp.js
// module id = 30
// module chunks = 0